import ReactGA from "react-ga";
import log from "loglevel";

export const sendPageView = (location: string) => {
  log.info("Sending Page View: " + location);
  ReactGA.set({ page: location });
  ReactGA.pageview(location);
};